'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectDestructuringEmpty2 = require('babel-runtime/helpers/objectDestructuringEmpty');

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/9/20.
                                   */

// import RadioGroup from 'react-radio';
// import GoeasyRadio from '../GoeasyInputField/GoeasyRadio';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 'payType',
var PaymentContent = (_dec = (0, _reduxForm.reduxForm)({
  form: 'paymentContentForm',
  fields: ['payPlatform']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PaymentContent, _Component);

  function PaymentContent() {
    (0, _classCallCheck3.default)(this, PaymentContent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PaymentContent).apply(this, arguments));
  }

  (0, _createClass3.default)(PaymentContent, [{
    key: 'onFieldChange',
    value: function onFieldChange(value, field) {
      var
      // payType,
      payPlatform = this.props.fields.payPlatform;
      /* if (field === 'payType') {
       if (payType.value !== value) {
       payType.onChange(value);
       }
       } else
       */

      if (field === 'payPlatform') {
        if (payPlatform.value !== value) {
          payPlatform.onChange(value);
        }
      }
    }
  }, {
    key: 'onPayPlatformClick',
    value: function onPayPlatformClick(payPlatform) {
      var onSubmitData = this.props.onSubmitData;

      console.log(payPlatform);
      if (onSubmitData) {
        onSubmitData({ payPlatform: payPlatform });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./PaymentContent.scss');
      var _props =
      // handleSubmit
      this.props;
      (0, _objectDestructuringEmpty3.default)(_props.fields);
      var
      // payType,
      // payPlatform
      info = _props.info;
      var orderNumber = _props.orderNumber;
      var activeId = _props.activeId;
      /*   let payInfo = '';
       if (info && info.payTypeList instanceof Array) {
       payInfo = info.payTypeList.map((payTypeInfo, index)=> {
       return <GoeasyRadio key={index} currentData={payTypeInfo} Id={'paymentContentFrom_payTypeInfo' + index}/>;
       });
       } */

      var payPlatformInfo = '';
      if (info && info.payPlatformList instanceof Array) {
        payPlatformInfo = info.payPlatformList.map(function (platformInfo, index) {
          var payPlatformImg = '';
          switch (platformInfo.value) {
            case 'M0042510000000000000000001':
              payPlatformImg = 'http://tupian.goeasy.cn:9999/yipinwang/third/weixinpay.png';
              break;
            case 'M0042510000000000000000002':
              payPlatformImg = 'http://tupian.goeasy.cn:9999/yipinwang/third/alipaylittle.png';
              break;
            default:
              payPlatformImg = '';
              break;
          }
          /*
           return (
           <GoeasyRadio key={index} customStyle={{marginTop: '7px'}} currentData={{...platformInfo, img: payPlatformImg}}
           page="chooseItemImg"
           Id={'paymentContentFrom_payPlatformList' + index}/>); */
          return _react2.default.createElement(
            'li',
            { key: 'payPlatform' + index, className: styles.payPlatform,
              onClick: function onClick() {
                return _this2.onPayPlatformClick(platformInfo.value);
              } },
            _react2.default.createElement('img', {
              src: payPlatformImg })
          );
        });
      }
      var urlAdress = '';
      if (activeId === 'M001538') {
        urlAdress = '/orderdetail/';
      } else if (activeId === 'M001794') {
        urlAdress = '/serviceorderconfirm/';
      }
      return _react2.default.createElement(
        'form',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          _react2.default.createElement(
            'div',
            { className: styles.pageTopTitle, style: { float: 'left' } },
            '支付方式'
          ),
          info.money ? _react2.default.createElement(
            'div',
            { className: styles.pageTopTitle,
              style: { float: 'right', color: '#ff0000' } },
            '支付金额：' + info.money
          ) : ''
        ),
        _react2.default.createElement(
          'ul',
          { className: styles.radio + ' ' + styles.payPlatformUl },
          payPlatformInfo
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: urlAdress + orderNumber },
          _react2.default.createElement(_SubmitBtn2.default, { style: { marginRight: 0 }, text: '查询订单' })
        )
      );
    }
  }]);
  return PaymentContent;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  closeModalFunc: _react.PropTypes.func,
  handleSubmit: _react.PropTypes.func,
  registerUrl: _react.PropTypes.string,
  hideCloseModalBtn: _react.PropTypes.bool,
  forgetPwdUrl: _react.PropTypes.string,

  info: _react.PropTypes.object.isRequired,
  orderNumber: _react.PropTypes.string,
  activeId: _react.PropTypes.string,
  onSubmitData: _react.PropTypes.func
}, _temp)) || _class);
exports.default = PaymentContent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PaymentContent/PaymentContent.js
 ** module id = 1391
 ** module chunks = 0
 **/